/**
 * A universal class to contain basic result count.
 * Could hold info about diag tests or other results - such as from a questionnaire.
 */
export class ResultsCount {
  public constructor(public count: number, public shortTitle: string, public color: string, public source: string) {}
}
